import { createAsyncThunk } from "@reduxjs/toolkit";
import { getMemberPortalInitData } from "../../utils/api/pages/memberPortalInit";
import { Member } from "../../types/employee.types";
import { GroupOwner } from "../../types/groupOwner.types";
import { Paycheck } from "../../types/paycheck.types";
import { LogoSettings } from "../../types/logoSettings.types";
import { Theme } from "../../types/theme.types";
import { EnrollmentSchema } from "../../types/enrollment.types";
export const fetchMemberPortalInitData = createAsyncThunk(
	"memberPortal/fetchInitData",
	async (
		groupOwnerToken: string | null
	): Promise<{
		member: Member;
		groupOwner: GroupOwner | null;
		paycheck: Paycheck;
		logoSettings: LogoSettings;
		theme: Theme;
		dependents: (Member & { enrollment: EnrollmentSchema })[];
	}> => {
		return await getMemberPortalInitData(groupOwnerToken);
	}
);
